export default __webpack_public_path__ + "static/media/progressBarStep1_horizontal.f295b2d6.svg";